import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { IServerError } from '@core/js/hooks/socket/types';
import { showCommonPopupAction } from '@core/js/components/common/popups/CommonPopup';

import * as constants from './constants';

export const useHandleLimitsErrorNotification = () => {
    const dispatch = useDispatch();

    // TODO: moved code from BB (app/notifications/solverde-theme/depositLimitsError.notification.js).
    /* Solverde changes */
    return useCallback((error: IServerError): void => {
        const { ID, data } = error;
        const tkPrefix = constants.TRANSLATIONS_MAP[ID];
        const isTimeoutError = data.errorCode === constants.TIMEOUT_ERROR_CODE;

        if (isTimeoutError) {
            const userError = Array.isArray(data.userErrors)
                    ? data.userErrors?.find(({ templateId }: any) => templateId === constants.TIMEOUT_CORRELATION_ID)
                    : undefined;

            userError && dispatch(showCommonPopupAction({
                title: `${constants.TRANSLATIONS_KEY_TIMEOUT}popupTitle`,
                content: `${constants.TRANSLATIONS_KEY_TIMEOUT}popupContent`
            }));

            return;
        } else if (constants.IGNORED_CORRELATION_IDS.includes(data.correlationId)) {
            return;
        }
        /* Solverde changes */

        dispatch(showCommonPopupAction({
            title: `${tkPrefix}popupTitle`,
            content: `${tkPrefix}popupContent`
        }));
    }, [dispatch]);
};
